module.exports = __webpack_public_path__ + "static/grocery-ecc42c9bb182cf32792069d2298c3889.jpg";